import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import PropertyForm from "../AddProperty/PropertyForm";
import Loader from "../../../components/Loader/Loader";
import { getPropertyById, updateProperty } from "../../../services/api";
import "./EditProperty.css";

export default function EditProperty() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [initial, setInitial] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    getPropertyById(id)
      .then((p) => {
        if (!cancelled) setInitial(p || null);
      })
      .catch((err) => {
        toast.error(err.message || "Failed to load property");
        if (!cancelled) setInitial(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  const onSubmit = async (payload) => {
    setSaving(true);
    try {
      const res = await updateProperty(id, payload);
      toast.success(res.message || "Property updated successfully");
      navigate("/admin/property-list");
    } catch (err) {
      toast.error(err.message || "Failed to update property");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="ep">
      <div className="ep-eyebrow">Inventory</div>
      <h1 className="ep-title">Edit Property</h1>
      <p className="ep-sub">
        Update details, media, units and publishing options.
      </p>

      <div className="ep-form">
        {loading && <Loader label="Loading property…" />}
        {!loading && !initial && (
          <p className="ep-missing">Property not found.</p>
        )}
        {!loading && initial && (
          <PropertyForm
            initial={initial}
            onSubmit={onSubmit}
            submitting={saving}
          />
        )}
      </div>
    </div>
  );
}